import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { CacheService } from './cache.service';
import { ItemDigitalLibrary } from '../model/classes/digitalLibrary.class';
import { ProductsParametrization } from '../model/interfaces/itemLibrary.interface';

@Injectable()
export class DigitalLibraryService {
  baseUrl = 'api/DigitalLibrary';

  constructor(private sxHttp: SxHttpService, private cacheService: CacheService) { }

  /**
   * Get all libraries to the systemselected
   * @param systemCode
   */
  getAll(systemCode: string): Observable<ItemDigitalLibrary[]> {
    return this.sxHttp
      .get(`${this.baseUrl}/getAll/${systemCode}`)
      .map(response => response.json().data as ItemDigitalLibrary[]);
  }

  /**
   * Get all libraries to the system selected by type
   * @param systemCode
   * @param businessCode
   * @param itemType
   */
  getAllByType(systemCode: string, itemType: string): Observable<ItemDigitalLibrary[]> {
    return this.sxHttp
      .get(`${this.baseUrl}/getAll/${systemCode}/${itemType}`)
      .map(response => response.json().data as ItemDigitalLibrary[]);
  }

  /**
   * Return a library from the backend
   * @param id the Id to search
   */
  /*getItem(id: string): Observable<ItemLibrary> {
    return this.sxHttp
      .get(`${this.baseUrl}/getById/${id}`)
      .map(result => result.json().data as ItemLibrary);
  }*/

  /**
   * It imports the configuration of the selected product
   * @param systemCode
   * @param businessCode
   * @param itemId
   */
  importProductConfiguration(systemCode: string, businessCode: string, itemId: string): Promise<string> {
    const url = `${this.baseUrl}/productConfiguration/${systemCode}/${businessCode}/${itemId}`;
    return this.sxHttp.post(url, null)
      .toPromise().then(response => response.json().data as string);
  }

  /**
   * Get product template for configuration
   * @param systemCode
   * @param businessCode
   * @param itemId
   */
  getTemplate(systemCode: string, businessCode: string, itemId: string): Observable<any> {
    const url = `${this.baseUrl}/getTemplate/${systemCode}/${businessCode}/${itemId}`;
    return this.sxHttp.get(url).map(result => result.json().data);
  }

  /**
   * Request product template for configuration
   * @param systemCode
   * @param businessCode
   * @param itemId
   * @param items
   */
  requestTemplate(systemCode: string, businessCode: string, itemId: string, items: ProductsParametrization): Observable<number> {
    const url = `${this.baseUrl}/requestTemplate/${systemCode}/${businessCode}/${itemId}`;
    return this.sxHttp
      .post(url, items)
      .map(response => response.json().data as number);
  }

  /**
   * Get import progress
   * @param systemCode
   * @param businessCode
   * @param transactionId
   */
  getImportProgress(systemCode: string, businessCode: string, transactionId: number): Observable<any> {
    const url = `${this.baseUrl}/getProgress/${systemCode}/${businessCode}/${transactionId}`;
    return this.sxHttp.get(url, null, false).map(result => result.json().data);
  }

  publishProduct(systemCode: string, businessCode: string, productCode: string, library: ItemDigitalLibrary): Observable<boolean> {
    const url = `${this.baseUrl}/publish/${systemCode}/${businessCode}/${productCode}`;

    return this.sxHttp
      .post(url, library)
      .map(response => response.json().data as boolean);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/digitalLibrary.service.ts